module.exports = __webpack_public_path__ + "img/barbershop-gaoubouzi-bouzi-project.f67cef9f.png";